import { LOCAL_STORAGE_KEY } from 'constants/browserCache';
import { getLocalStorageItem } from 'utils/browserCache';

export const isDebugMode = () =>
  Boolean(getLocalStorageItem(LOCAL_STORAGE_KEY.CVNA_CHAT_UI_DEBUG_MODE));
